/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'password-big': {
    width: 16,
    height: 16,
    viewBox: '0 0 96 96',
    data: '<defs/><g id="复杂大型图标"><circle pid="0" class="cls-1" cx="48" cy="62" r="8"/><path pid="1" class="cls-1" d="M36 34h24v.01H36z"/><path pid="2" class="cls-2" d="M28 26v8h8v-8a12 12 0 0 1 12-12V6a20 20 0 0 0-20 20z"/><path pid="3" class="cls-3" d="M50 6.09A18.46 18.46 0 0 0 48 6v8a12 12 0 0 1 12 12v8h8v-7.15c0-10.44-7.64-19.76-18-20.76z"/><path pid="4" class="cls-4" d="M68 34v-2.05L60.33 34H68zM36 34v-2.05L28.33 34H36z"/><path pid="5" class="cls-2" d="M40 62a8 8 0 0 1 14-5.21l26-22.74H16V90h.15L42 67.31A8 8 0 0 1 40 62z"/><path pid="6" class="cls-3" d="M80 90V34.05L54.05 56.79A8 8 0 0 1 56 62a7.89 7.89 0 0 1-.8 3.46L79.74 90z"/><path pid="7" class="cls-4" d="M48 70a8 8 0 0 1-6-2.69L16.15 90h63.59L55.2 65.46A8 8 0 0 1 48 70z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/password-big.js